import { getRequest, postRequest } from 'utils/request';
import type { Product, ProductDetail } from 'types/models/listings';
import type { Response, PaginatedResponse } from 'types/api';

export const getCategories = (): Promise<Response<any>> => getRequest('/directory/categories');

export interface DirectorySearchParams {
  query: string | null;
  categoryId: string | null;
  revSplit: string | null;
  inventory: number | null;
  brands: string[] | null;
  minPrice: string | null;
  maxPrice: string | null;
  sort: string | null;
  sortDir: 'asc' | 'desc' | null;
  limit: number;
  next?: string;
  prev?: string;
}
// add search product schema to type response
export const getDirectoryProducts = (
  params: DirectorySearchParams
): Promise<PaginatedResponse<Product[]>> => getRequest('/directory', params);

// Get individual product details by ID
export const getProductDetails = (productId: string): Promise<Response<ProductDetail>> =>
  getRequest(`/directory/products/${productId}`);

// Discover — store a marketplace search query
export interface CreateMarketplaceSearchParams {
  query: string;
}

export const createMarketplaceSearch = (
  params: CreateMarketplaceSearchParams
): Promise<Response<unknown>> => postRequest('/marketplace/searches', params);
